import siftLib, { Query } from 'sift';

type Options = Parameters<typeof siftLib>[1];

export const evalCondition = <TItem>(query: Query<TItem>, options: Options = {}) => {
  return siftLib(query, options);
};
